import './style.css'
import ReactDOM from 'react-dom/client'
import Experience from './Experience.jsx'
import UI from './UI.jsx'
import { Canvas } from '@react-three/fiber'
import { Suspense } from 'react'
import { Analytics } from "@vercel/analytics/react"
import Wobble from './Wobble.jsx'
import { DSLloader } from './dslLoader.tsx'
import SpaceComm from './spacecomm/SpaceComm.jsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
   <>  
        <Canvas
            className="r3f"
            shadows
            dpr={[1,2]}
            camera={{ 
                position: [ -1.9, 0.0, -1.9 ], 
                fov: 90,
                near: 0.001,
                }}
        >
                <Suspense fallback={null}>
                    <Experience />
                </Suspense>

        <Analytics/>
        
        </Canvas>
        
        <DSLloader />
        <Wobble />
        <UI />
                            <SpaceComm />

    </>
)


